import React from "react";
import { Box } from "@mui/material";
import { useSelector } from "react-redux";
import { useIntl } from "react-intl";
import { hausifyLogoTransparent } from "../../assets";
import LocationFilterToolbar from "../../App/LocationFilterToolbar";
import AppBar from "../../components/DefaultAppBar";
import PostingContainer from "../PostingContainer/PostingContainer";
import TicketCreateButton from "../TicketListContainer/TicketCreateButton";
import Logo from "./Logo";
import TicketListContainer from "../TicketListContainer/TicketListContainer";

export const route = "/";

const HomeContainer = () => {
  const intl = useIntl();
  const propertyManagement = useSelector((state) => state.propertyManagement);

  const formatMessage = intl.formatMessage;
  const ticketsTitle = formatMessage({ id: "dashboard.tickets.title" });
  const postingsTitle = formatMessage({ id: "dashboard.postings.title" });

  const logoFallback = {
    filename: hausifyLogoTransparent,
    name: "Hausify Logo",
  };
  const logo = (propertyManagement && propertyManagement.logo) || logoFallback;

  return (
    <div>
      <AppBar>
        <LocationFilterToolbar />
      </AppBar>

      <Box sx={{ mb: 4 }}>
        <Logo logo={logo} />
      </Box>

      <Box sx={{ mb: 4 }}>
        {/* This containers responsibility is to show all available postings */}
        <PostingContainer title={postingsTitle.toUpperCase()} />
      </Box>

      <Box sx={{ mb: 4 }}>
        <TicketListContainer title={ticketsTitle.toUpperCase()} />
      </Box>

      {/* FAB button */}
      <TicketCreateButton />
    </div>
  );
};

// keep the route property for router registration elsewhere
HomeContainer.route = route;

export default HomeContainer;
